import React, { useEffect, useMemo, useState } from "react";
import { isEmpty } from "lodash";
import moment from "moment";

import { CloseButton } from "components";

import styles from "./banner.module.scss";

export type LoginBannerProps = {
	body: React.ReactNode | JSX.Element;
	expirationDate: string;
	name: string;
};

const BannerManager = ({ body, expirationDate, name }) => {
	const keyName = `${name}-closeDate`;

	const now = moment().format();
	const expirationDateFormated = moment(expirationDate).format();

	const storage = window?.localStorage?.getItem?.("loginBanner");
	const storageFormated = useMemo(
		() => (storage ? JSON.parse?.(storage) : {}),
		[storage],
	);

	const [isBannerHidden, setBannerToHidden] = useState<boolean>(true);

	useEffect(() => {
		if (now > expirationDateFormated) {
			setBannerToHidden(true);
		} else {
			if (!isEmpty(storageFormated?.[keyName])) {
				setBannerToHidden(true);
			} else {
				setBannerToHidden(false);
			}
		}
	}, [expirationDateFormated, keyName, now, storageFormated]);

	const onCloseClick = () => {
		const value = {
			...storageFormated,
			[keyName]: moment().format(),
		};

		localStorage.setItem("loginBanner", JSON.stringify(value));
		setBannerToHidden(true);
	};

	if (!isBannerHidden)
		return (
			<div className={styles.banner}>
				<div className={styles.bannerHeader}>
					<CloseButton onClick={onCloseClick} />
				</div>
				<div className={styles.bannerBody}>{body}</div>
			</div>
		);
};

export default BannerManager;
